import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import DownloadIcon from '@components/Icon/DownloadCircled'

function DownloadEplPdfLink ({ epl }) {
  return (
    <a
      href={`/api/epl/extern/${epl.epl.hash}/export`}
      className='link expert-form__section__top-right-item'
      download
    >
      <DownloadIcon />
      PDF
    </a>
  )
}

DownloadEplPdfLink.propTypes = {
  epl: PropTypes.object
}

export default observer(DownloadEplPdfLink)
